import { render, staticRenderFns } from "./QuestionTypeTest.vue?vue&type=template&id=d90fc42a&"
import script from "./QuestionTypeTest.vue?vue&type=script&lang=js&"
export * from "./QuestionTypeTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports